import {
	MAP_TEXT_EDITOR_SET_TEXT,
	MAP_TEXT_EDITOR_FINISH_EDIT
} from './map-text-editor.actions';
import produce from 'immer';
import {
	IMapTextEditorState,
	ITextMapDrawing,
	TextMapDrawingAction
} from './map-text-editor.types';

const mapTextEditorInitialState: IMapTextEditorState = {};

export function mapTextEditorReducer(
	state: IMapTextEditorState = mapTextEditorInitialState,
	action: TextMapDrawingAction
): IMapTextEditorState {
	switch (action.type) {
		case MAP_TEXT_EDITOR_SET_TEXT:
			return setCurrentText(state, action.payload);
		case MAP_TEXT_EDITOR_FINISH_EDIT:
			return setCurrentText(state);
		default:
			return state;
	}
}

function setCurrentText(
	currentState: IMapTextEditorState,
	textDrawing?: ITextMapDrawing
): IMapTextEditorState {
	return produce(currentState, (draftState: IMapTextEditorState) => {
		draftState.currentText = textDrawing;
	});
}
